// src/components/erp/PageHeader.jsx
import CanonicalPageHeader from "../ui/PageHeader";

/**
 * Legacy adapter (UI-1). Existing pages keep `title`, `subtitle` and action
 * `children`; the canonical PageHeader draws them. `eyebrow` is accepted and
 * no longer shown: the topbar breadcrumb carries the module (DESIGN.md ›
 * Typography › The No Eyebrow Rule).
 */
// eslint-disable-next-line no-unused-vars
export default function PageHeader({ eyebrow, title, subtitle, children }) {
  return <CanonicalPageHeader title={title} description={subtitle} actions={children} />;
}
